// import './index.css';
import { Button, Form, Input, Spin, message } from 'antd';
import { createContext, useCallback, useEffect, useState } from 'react';
import {
  MandateLinkFormType,
  MandateLinkPayload,
  // cancelMandateLink,
  getNachLoanDetails,
  getNachMasterLevelDetails,
} from 'api/nach';
import MandateLinkGrids from './MandateLinkGrids';
import MandateLinkForm from './MandateLinkForm';
import NachWrapper from 'features/nach/components/NachWrapper';

import NachSelectionTabs from '../components/NachSelectionTabs';
// import ConfirmationModel from '../../components/ConfirmationModel';

export const SourceConfigContext = createContext<any>({});

type Props = {
  isAdmin: boolean;
  onSubmit: (payload: any) => void;
};
function MandateLink({}: Props) {
  const [form] = Form.useForm();
  const [gridForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const [search, setSearch] = useState('');
  const [mandateAmount, setMandateAmount] = useState<any>(null);
  const [maxBillAmount, setMaxBillAmount] = useState<any>(null);

  const [checkedRecord, setCheckedRecord] = useState();
  const [fetchedData, setFetchedData] = useState<MandateLinkPayload[]>([]);
  const [mandateData, setMandateData] = useState<MandateLinkPayload[]>();
  const [mandateFormData, setMandateFormData] = useState<MandateLinkFormType>();
  const [pnach, setPnach] = useState(false);
  const [autoPay, setAutoPay] = useState(false);
  const [enach, setEnach] = useState(false);
  const [isVisiblePnach, setIsVisiblePnach] = useState(false);
  const [isVisibleEnach, setIsVisibleEnach] = useState(false);
  const [isVisibleAutoPay, setIsVisibleAutoPay] = useState(false);
  const [loanAmount, setLoanAmount] = useState('');

  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMandateCancel, setIsMandateCancel] = useState(false);
  const [CIFlist, SetCIFlist] = useState<string[]>([]);
  const [selectedCIFId, setSelectedCIFId] = useState<string | undefined>(undefined);
  const [filteredMandateData, setFilteredMandateData] = useState<MandateLinkPayload[]>([]);
  const [selectedAutopayTabValue, setSelectedAutopayTabValue] = useState<boolean>(false);
  // const [selectedAutopayTabValue, setSelectedAutopayTabValue] = useState<boolean>(false);
  const [selectedEnachTabValue, setSelectedEnachTabValue] = useState<boolean>(false);
  // const [selectedPnachTabValue, setSelectedPnachTabValue] = useState<boolean>(false);

  const handleCIFChange = (cifId: string) => {
    // New handler for changing CIF ID
    setSelectedCIFId(cifId);
    // You can perform other actions here if needed
  };

  console.log('cIFID In Mandate Link ', selectedCIFId);

  useEffect(() => {
    const sourceId = sessionStorage.getItem('sourceId');
    if (sourceId) {
      console.log('source Id', sourceId);
      getNachMasterLevelDetails({ sourceId: sourceId })
        .then((res) => {
          console.log('source res', res);
          if (res.status === 'SUCCESS') {
            setIsVisibleAutoPay(res.data?.isAutoPay == '1');
            if (res.data?.nachId == 1) {
              setIsVisibleEnach(true);
            } else if (res.data?.nachId == 2) {
              setIsVisiblePnach(true);
            } else if (res.data?.nachId == 3) {
              setIsVisibleEnach(true);
              setIsVisiblePnach(true);
            }
          }
        })
        .catch((err) => {
          console.log(err);
          message.error('Something went wrong', 2);
        });
    }
  }, []);

  useEffect(() => {
    if (fetchedData) {
      const newData: MandateLinkFormType = {
        loanTenor: fetchedData[0]?.loanTenor || '',
        cIFId: fetchedData[0]?.cIFId || '',
        loanAmount: loanAmount,
      };

      setMandateFormData(newData);

      const modifiedData = fetchedData.length > 0 && [...fetchedData];

      setMandateData(modifiedData as any);
      // console.log('mandate data in MandateLink', mandateData);

      setCheckedRecord(undefined);
    }
  }, [fetchedData]);

  console.log('Fetched data from mandate link is', fetchedData);

  useEffect(() => {
    if (mandateData && selectedCIFId) {
      const filteredData = mandateData.filter((item) => item.cIFId === selectedCIFId);
      const emptyField = {
        emailId: '',
        mobileNumber: '',
        customerName: '',
        id: 'input',
        accountName: '',
      };
      const filterMandateData = filteredData.length > 0 && [...filteredData, emptyField];

      setFilteredMandateData(filterMandateData as any);
    }
    // else {
    //   setFilteredMandateData(mandateData || []); // Reset to original data if no CIF ID is selected
    // }
  }, [mandateData, selectedCIFId]);

  // console.log('Filtered Mandate Data ', filteredMandateData);

  const searchHandleSubmit = useCallback(() => {
    const value = form.getFieldsValue();
    if (!value || !value.lanNumber) {
      message.error('Please enter LAN Number', 1);
      return;
    }

    const fetchLanData = async () => {
      setIsLoading(true);
      getNachLoanDetails(value)
        .then((res) => {
          if (res.status == 'SUCCESS') {
            message.success('Data fetched successfully', 1);

            const ids = res.data.map((item: any) => item.cIFId);
            SetCIFlist(ids);
            setFetchedData(res.data);
            setLoanAmount(res.data[0]?.loanAmount as string);
            const processedData = res?.data?.map((item: any, index: any) => ({
              ...item,
              id: index + '',
            }));
            setFetchedData(processedData);
            setSelectedAutopayTabValue(false);
            setSelectedEnachTabValue(false);
            //setIsModalOpen(res.data[0]?.mandateStatus == 'RECORD_EXISTS');
            //setIsMandateCancel(res.data[0]?.mandateStatus != 'RECORD_EXISTS');
          } else if (res.status == '500') {
            message.destroy();
            message.warning(res.message);
            // message.error(res.message);
          } else {
            setFetchedData([]);
            setLoanAmount('');
          }
        })
        .catch((err) => {
          console.log(err);
          setFetchedData([]);
          setLoanAmount('');
          message.error('Something went wrong', 2);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };
    fetchLanData();
  }, [search]);
  // const onOkHandler = useCallback(() => {
  //   const loggedInUserId = sessionStorage.getItem('userId') as any;
  //   if (!fetchedData[0] || !fetchedData[0].mandateId) {
  //     return;
  //   }
  //   cancelMandateLink({ loggedInUserId, mandateId: fetchedData[0]?.mandateId || 0 })
  //     .then((res) => {
  //       if (res.status === 'SUCCESS') {
  //         console.log('mandate cancel id', res);
  //         message.success('Successfully cancel mandate link.', 1);
  //         setIsModalOpen(false);
  //         setIsMandateCancel(true);
  //       }
  //     })
  //     .catch(() => {});
  // }, [fetchedData]);

  // const handleCancel = () => {
  //   if (!isMandateCancel) {
  //     setIsModalOpen(false);
  //   }
  // };

  const SourceConfigContextData = {
    autoPay,
    setAutoPay,
    enach,
    setEnach,
    pnach,
    setPnach,
    setFetchedData,
    checkedRecord,
    fetchedData,
    mandateAmount,
    isVisibleAutoPay,
    setIsVisibleAutoPay,
    isVisibleEnach,
    setIsVisibleEnach,
    isVisiblePnach,
    setIsVisiblePnach,
    gridForm,
    // setIsModalOpen,
    setIsMandateCancel,
    isMandateCancel,
    maxBillAmount,
    setMaxBillAmount,
  };
  console.log('filteredMandateData  ', filteredMandateData);
  console.log('Grid form', gridForm);
  console.log('Selected CIFID', selectedCIFId);

  return (
    <NachWrapper title="Create Mandate Link" className="customerRedirectLink">
      <Spin spinning={false}>
        <>
          {/* <ConfirmationModel
            setIsModalOpen={setIsModalOpen}
            isModalOpen={isModalOpen}
            handleOk={onOkHandler}
            mandateId={fetchedData[0]?.mandateId}
            // lanNo={fetchedData}
            handleCancel={handleCancel}
          /> */}
          <Form form={form} layout="vertical" scrollToFirstError onFinish={searchHandleSubmit}>
            <div className="row">
              <Form.Item name="lanNumber" className="fieldTitle">
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '10px',
                  }}
                >
                  <label style={{ fontSize: '17px', fontWeight: '600' }}> ENTER LAN : &nbsp;</label>
                  <div
                    className="col-sm-5 col-md-4"
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                  >
                    <div
                      className="input-box"
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '0px',
                      }}
                    >
                      <Input
                        size="middle"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Enter LAN"
                      />
                    </div>
                  </div>
                  <Button role="button" htmlType="submit" type="primary">
                    Search
                  </Button>
                </div>
              </Form.Item>
            </div>
          </Form>
          <MandateLinkForm
            mandateAmount={mandateAmount}
            setMandateAmount={setMandateAmount}
            setMaxBillAmount={setMaxBillAmount}
            maxBillAmount={maxBillAmount}
            isLoading={isLoading}
            data={mandateFormData}
            setMandateFormData={setMandateFormData}
            autoPay={autoPay}
            setAutoPay={setAutoPay}
            CIFlist={CIFlist || []} // Default to empty array if CIFlist is undefined
            onCIFChange={handleCIFChange}
            selectedAutopayTabValue={selectedAutopayTabValue}
            setSelectedAutopayTabValue={setSelectedAutopayTabValue}
            selectedEnachTabValue={selectedEnachTabValue}
            setSelectedEnachTabValue={setSelectedEnachTabValue}
          />

          {filteredMandateData && (
            <MandateLinkGrids
              form={gridForm}
              mandateLinkData={filteredMandateData}
              checkedRecord={checkedRecord}
              setCheckedRecord={setCheckedRecord}
              selectedCIFId={selectedCIFId}
            />
          )}
        </>

        {fetchedData &&
        fetchedData.length > 0 &&
        checkedRecord &&
        mandateAmount > 0 &&
        maxBillAmount > 0 &&
        maxBillAmount <= parseInt(loanAmount) / 100 &&
        mandateAmount <= parseInt(loanAmount) / 100 ? (
          <>
            <SourceConfigContext.Provider value={SourceConfigContextData}>
              <NachSelectionTabs
                gridForm={gridForm}
                setSelectedAutopayTabValue={setSelectedAutopayTabValue}
                selectedAutopayTabValue={selectedAutopayTabValue}
                setSelectedEnachTabValue={setSelectedEnachTabValue}
                selectedEnachTabValue={selectedEnachTabValue}
              />
            </SourceConfigContext.Provider>
          </>
        ) : null}
      </Spin>
    </NachWrapper>
  );
}

export default MandateLink;
